import React from 'react'

import classnames from 'classnames'

import Icons, { IconPrefix } from 'common/components/icons'
import Button from 'common/components/button'

import '@hotmart/cosmos/dist/styles/utilities/spacing/spacing.css'
import './iconButton.scss'

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  iconName: string,
  prefix?: IconPrefix
}

const IconButton = ({ iconName, className, prefix = 'far', ...props }: IconButtonProps) => (
  <Button
    outline
    data-test="button"
    {...props}
    className={classnames('icon-button _p-0', iconName, className)}>
    <Icons className="icon" iconName={iconName} prefix={prefix} data-test="icon" />
  </Button>
)

export default IconButton
